<template lang="pug">
	.toolbox-preview.animated.fadeIn
		.controls(v-if="Publisher.SelectedPublisher && Publisher.SelectedPublisher.id")
			.left-controls(v-if="Project.SelectedProject && Project.isSelectedProjectLoaded()")
				.control-button.duplicate-version(v-if="Version.canCopyVersion()" @click="saveAs" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Duplicate project version'}")
					i.fa.fa-copy
				.global-search-wrapper#global-search-wrapper
					.global-search(:class="{'filter-exists': globalSearchFilter && globalSearchFilter.length}")
						i.fa.fa-search
						input.search-input(ref="input" placeholder="Global search" v-model="globalSearchFilter" @click="showGlobalSearch" :style="{'width': 'calc((100vw - 1100px) / 2 - 150px)', minWidth: '85px'}")
						i.fa.fa-remove(@click="removeGlobalSearchFilter")
					ProjectsGlobalSearch(:parent="'#global-search-wrapper'" :searchValue="globalSearchFilter")
			.device-control(v-if="Project.SelectedProject && Project.isSelectedProjectLoaded() && (Project.SelectedProject.type === 'playable' || Project.SelectedProject.type === 'end-card')")
				.control-button
					.icon.iphonex(:class="{selected: Layout.previewDevice === 'iPhoneX', landscape: Layout.previewOrientation['iPhoneX'] === 'landscape'}" @click="Layout.togglePreviewDevice('iPhoneX')" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: '19.5 : 9<br>Press to rotate', html: true}")
				.control-button
					.icon.iphone(:class="{selected: Layout.previewDevice === 'iPhone', landscape: Layout.previewOrientation['iPhone'] === 'landscape'}" @click="Layout.togglePreviewDevice('iPhone')" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: '16 : 9<br>Press to rotate', html: true}")
				.control-button
					.icon.ipad(:class="{selected: Layout.previewDevice === 'iPad', landscape: Layout.previewOrientation['iPad'] === 'landscape'}" @click="Layout.togglePreviewDevice('iPad')" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: '4 : 3<br>Press to rotate', html: true}")
				.control-button
					.icon.square(:class="{selected: Layout.previewDevice === 'square', landscape: Layout.previewOrientation['square'] === 'landscape'}" @click="Layout.togglePreviewDevice('square')" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: '1 : 1', html: true}")
			.right-controls(v-if="Project.SelectedProject && Project.isSelectedProjectLoaded()")
				.control-button.public-preview(v-if="Project.SelectedProject.type === 'playable' || Project.SelectedProject.type === 'banner'" @click="openPreview" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Open public preview link'}")
					i.fa.fa-external-link
				.control-button-separator(v-if="Project.SelectedProject.type === 'playable' || Project.SelectedProject.type === 'banner'" )
				.control-button(v-if="Project.SelectedProject.type === 'playable' || Project.SelectedProject.type === 'banner' || Project.SelectedProject.type === 'end-card'" )
					DownloadButton
				.control-button(v-if="Project.SelectedProject.type === 'playable' || Project.SelectedProject.type === 'banner' || Project.SelectedProject.type === 'end-card'" )
					UploadButton
				.control-button-separator(v-if="Project.SelectedProject.type === 'playable' || Project.SelectedProject.type === 'banner'" )
				.control-button(@click="refreshIFrame()" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Reload creative'}")
					i.fa.fa-refresh
				.control-button-separator(v-if="canDisplaySettings()")
				.control-button.settings(@click="Layout.toggleAside('testing')" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Testing'}" v-if="canDisplaySettings() && !Layout.asideOpened && Project.SelectedProject.Tags.cocos")
					i.fa.fa-legal
					.status.fa(:class="{'fa-circle-thin': testingStatus !== 'error' && testingStatus !== 'fully-passed', 'fa-circle': testingStatus === 'error' || testingStatus === 'fully-passed', [testingStatus]: true}")
				.control-button.settings(@click="Layout.toggleAside('settings')" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Settings'}" v-if="canDisplaySettings() && !Layout.asideOpened")
					i.fa.fa-gear
				.control-button(@click="Layout.toggleAside()" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Hide settings'}" v-if="Layout.asideOpened")
					i.fa.fa-angle-double-right
</template>

<script>

	import DownloadButton 				from './../../components/Header/DownloadButton'
	import UploadButton 				from './../../components/Header/UploadButton'
	import ProjectsGlobalSearch 		from "./../../components/Project/ProjectsGlobalSearch";

	import Screen 						from './../../mixins/screen';

	import { Publisher }				from '../../services/Publisher'
	import { Project }					from '../../services/Project'
	import { Version }					from '../../services/Version'
	import { Settings }					from '../../services/Settings'
	import { Asset }					from '../../services/Asset'
	import { Localization }				from '../../services/Localization'
	import { Layout } 					from './../../services/Layout'

	export default {
		name: 'ToolboxPreview',
		mixins: [Screen],
		screen: {
			updateOn: [
				"Layout Workspace Changed",
				"Aside State Changed",
				"Preview Device Changed",
				"Preview Orientation Changed",
				"Testing Step Added",
				"Testing Steps Cleared"
			],
			events: {
				"Selected Version Changed,Selected Project Fully Loaded": function() {

					if (Project.isSelectedProjectLoaded() && Version.SelectedVersion) this.update();

				},
				"Selected Project Changed,Aside State Changed,Sub Aside State Changed": function() {

					this.update();

				}
			}
		},
		components: {
			DownloadButton,
			UploadButton,
			ProjectsGlobalSearch
		},
		data() {

			return {
				globalSearchFilter: '',
				showed: true,
				testingStatus: ''
			};

		},
		methods: {

			collectData() {

				this.testingStatus = Testing.getMraidSDKStatus();

			},

			openPreview() {

				if (!Version.SelectedVersion) return;

				if (_.size(Version.VersionPreviewsByVersionByHash[Version.SelectedVersion.id]) > 0) Broadcast.call("Show ProjectVersionPreviewList");
				else Broadcast.call("Show ProjectVersionPreviewCreate");

			},
			canDisplaySettings() {

				if (User.currentUser && User.currentUser.isAdmin) return true;
				if (!Publisher || !Publisher.SelectedPublisher || Publisher.SelectedPublisher.options.DisableProjectSettingsButton) return false;
				return true;

			},
			saveAs() {

				Broadcast.call("Show ProjectVersionActionsDuplicate");

				Broadcast.call("Pseudo Modal Hide", ['project-settings-options-dropdown']);

			},
			removeGlobalSearchFilter() {
				this.globalSearchFilter = '';
			},
			refreshIFrame() {

				Broadcast.call("Refresh Iframe");
			},
			showGlobalSearch() {
				Broadcast.call("Show ProjectsGlobalSearch");
			}
		}
	}
</script>

<style lang="sass">

	.toolbox-preview
		position: absolute
		top: 0
		left: 440px
		width: calc(100% - 440px)
		height: 46px
		z-index: 2
		transition: width 0.2s ease-in-out

		.controls
			background-color: #343b41
			border-bottom: 1px solid #23282c
			width: 100%
			height: 46px
			text-align: center
			z-index: 1

		.device-control
			display: inline-block
			width: 180px
			margin-top: 8px
			margin-right: 130px

			.control-button
				display: inline-block
				cursor: pointer
				margin: 0 5px 0 5px
				width: 30px
				height: 30px
				color: #000
				text-align: center
				font-size: 12px
				line-height: 20px

				.icon
					height: 30px
					display: inline-block

					&.iphone
						width: 16px
						background: url("../../../public/img/devices/device-icon-iphone.png") left no-repeat

					&.ipad
						width: 21px
						background: url("../../../public/img/devices/device-icon-ipad.png") left no-repeat

					&.iphonex
						width: 16px
						background: url("../../../public/img/devices/device-icon-iphonex.png") left no-repeat

					&.square
						width: 26px
						background: url("../../../public/img/devices/device-icon-square.png") left no-repeat

					&.selected
						background-position: right

					&.square.selected
						background-position: -25px

		.global-search-wrapper
			margin-left: 10px

			.global-search
				display: flex
				flex-direction: row
				height: 30px
				align-items: center
				background-color: rgba(255, 255, 255, 0.02)
				border: 1px solid rgba(255, 255, 255, 0.04)
				border-radius: 3px
				transition: border-color 0.35s ease-in-out, box-shadow 0.35s ease-in-out, color 0.35s ease-in-out, -webkit-box-shadow 0.35s ease-in-out

				>i.fa-search, i.fa-remove
					padding: 10px
					transition: opacity 0.35s ease-in-out

				>i.fa-search
					opacity: 0.1
				>i.fa-remove
					opacity: 0
					pointer-events: none

				>input
					border: unset
					color: rgba(255, 255, 255, 0.17)
					background-color: unset
					outline: none
					width: 180px
					transition: color 0.35s ease-in-out
					line-height: 1.5

			&.focused
				.global-search
					border-color: rgba(255, 255, 255, 0.18)
					background-color: rgba(255, 255, 255, 0.10)

					>input
						color: white

					>i.fa-search
						opacity: 1

					&.filter-exists
						>i.fa-remove
							opacity: 1
							pointer-events: auto
							cursor: pointer

		.left-controls
			display: flex
			flex-direction: row
			position: absolute
			left: 0
			top: 0
			height: 46px
			line-height: 44px
			color: #e4e7ea
			justify-content: center
			align-items: center


			.global-search-button
				color: #e4e7ea
				font-size: 12px
				cursor: pointer
				border-radius: 7px
				background-color: #3a4149
				border: 1px solid #23282c
				display: flex
				flex-direction: row
				gap: 5px
				align-items: center

				&:hover
					color: white
					background-color: #30353a

				.fa-globe
					transform: translate(-2px, -0.5px) scale(0.6)

			.control-button
				display: inline-block
				cursor: pointer
				margin: 0 5px 0 5px
				width: 30px
				height: 46px
				text-align: center
				line-height: 44px

			.control-button:hover
				color: #fff

			.control-button.disabled
				color: #e4e7ea
				opacity: 0.2

		.right-controls
			display: flex
			flex-direction: row
			position: absolute
			right: 5px
			top: 0
			height: 46px
			line-height: 44px
			color: #e4e7ea

			.control-button
				display: inline-block
				cursor: pointer
				margin: 0 5px 0 5px
				width: 30px
				height: 46px
				text-align: center
				line-height: 44px
				position: relative

				.status
					position: absolute
					right: 0
					top: 13px
					font-size: 8px

				.status.not-passed
					color: var(--red)

				.status.partially-passed
					color: var(--green)

				.status.fully-passed
					color: var(--green)

				.status.error
					color: var(--red)

			.control-button:hover
				color: #fff

			.control-button.disabled
				color: #e4e7ea
				opacity: 0.2

		.icon.landscape
			transform: rotate(-90deg)

		.control-button-separator
			display: inline-block
			width: 1px
			height: 25px
			background: rgba(0, 0, 0, 0.2)
			margin: 10px 5px

	body.aside-menu-show .toolbox-preview
		width: calc(100% - 440px - 390px)

</style>

